import styled from 'styled-components';

export const ZillowNavbarSubSectionLinksColumnatedListContainer = styled.li`
    & + & {
        margin-left: 20px;
    }
`;
